module.exports = __webpack_public_path__ + "static/cloud-devops-7958ddb21efc48cacebe30f5dc667c67.png";